import React from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends React.Component {
	componentDidUpdate(prevProps) {
		const prev = prevProps.location.pathname;
		const next = this.props.location.pathname;
		const hash = this.props.location.hash;
		if (prev === next) return;
		// Let home hash sections scroll into view (#plan, #places, #journey)
		if (next === '/' && hash) return;
		window.scrollTo(0, 0);
	}

	render() {
		return null;
	}
}

export default withRouter(ScrollToTop);
